import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool} from '../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';
import createActivityInfoExport from "./createActivityInfoExport";
import moment from "moment";

let {WizContainer, WizReduxTemplate} = framework_tool
let {WizBrowserExport, WizModal} = component_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const _getValue = (type, key) => {
  const values = {
    partType: {
      0: '课程',
      1: '考试',
      2: '投票',
      3: '系列化课程',
      4: '图片',
      5: '链接',
      6: '视频',
    },
    userType: {
      0: '培训平台用户',
      3: 'OEM部门用户',
      4: '经销商用户',
      5: '服务商用户'
    },
  }
  return values[type][key]
}


function getActivityInfo(data) {
  let dataInfo = []
  if (data && data.length) {
    dataInfo = data
    dataInfo.forEach(d => {
      if (d['activity']) {
        d['name'] = d['activity'].name
        d['apply'] = d['activity'].apply
        d['state'] = d['activity'].state
        d['sponsor'] = d['activity'].sponsor
        d['activityTime'] = d['activity'].activityTime
        d['participateNum'] = d['activity'].participateNum
        if (d['partList'] && d['partList'].length) {
          let i = 0
          d['partList'].forEach(p => {
            i++;
            d['title_' + i] = p['title']
            d['partTime_' + i] = p['partTime']
            d['partType_' + i] = p['partType']
          })
        }
      }
    })
  }

  return dataInfo;
}

class ActivityManager extends WizContainer {
  componentName = 'activityManager'

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['activity']['state'] === 0 ? e['activity']['state'] = "关闭" : e['activity']['state'] = "打开"
        e['activity']['apply'] === 0 ? e['activity']['apply'] = "否" : e['activity']['apply'] = "是"
        e['activity']['activityTime'] = formatterDate(e['activity']['startTime']) + ' ~ ' + formatterDate(e['activity']['endTime'])
        if (e['partList'] && e['partList'].length) {
          e['partList'].forEach(d => {
            d['partTime'] = formatterDate(d['startTime']) + ' ~ ' + formatterDate(d['endTime'])
            d['partType'] = _getValue('partType', d['type'])
          })
        }
      })
      let columnDefs = createActivityInfoExport(this, data)
      let dataInfo = getActivityInfo(data)
      WizBrowserExport({
        title: '活动信息',
        sheetName: '活动信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataInfo,
        filename: '活动信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleParticipateFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '学员姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '学员账户',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户类型',
        field: 'userType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '参加活动时间',
        field: 'participateTime',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      let activity = data['activity']
      let participateInfos = data['participateInfos']
      activity['apply'] == 0 ? activity['apply'] = "否" : activity['apply'] = "是"
      let str = '活动名称：'+activity['name']+'\n'
        +'活动时间：'+moment(activity['startTime']).format("YYYY-MM-DD HH:mm")+' ~ '+moment(activity['endTime']).format("YYYY-MM-DD HH:mm")
        // +'\n'+ '是否需要报名：'+activity['apply']
      participateInfos.forEach(e => {
        e['userType'] =_getValue('userType',e['userType']) 
      })
      WizBrowserExport({
        title: str,
        sheetName: '活动参加记录',
        columns: columnDefs.filter((_, index) => index),
        rows: participateInfos,
        filename: '活动参加记录.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 50
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _templateConfig = templateConfig({
      _btnFun: (e) => {
        if (e && e.rows && e.rows.length && e.rows.length === 1) {
          let record = {}
          e.rows.forEach(d => {
            record = d
          })
          switch (e.type) {
            case 'part' :
              this.jumpPage('push', '/interact/activity/activityDetailToPart', record);
              break;
            case 'topic' :
              this.jumpPage('push', '/interact/activity/activityTopic', record);
              break;
            case 'message' :
              this.jumpPage('push', '/interact/activity/activityMessage', record);
              break;
          }
        } else {
          WizModal.confirm({
            title: '请选择一条数据',
            onOk: () => {
            },
            onCancel() {
            }
          })
        }
      },
    })
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        export: this._handleFile,
        enable: (nextProps, nextState, key) =>{
          let o = nextProps[key]
          if (o['success']) {
            wizNotice.success(o['msg']);
            let bizIds = o['data']
            if(bizIds){
              if(bizIds>0){

              WizModal.confirm({
                title: '注意', content:"消息通知内容有变更，是否重新发送消息通知",cancelText:"否",okText:"是",
                onOk: () => {
                  this.doAction({
                    path:  "notice/sendNotice",
                    payload: {
                      key: "sendNoticeKey",
                      apiParams: {
                        bizId: bizIds,
                        bizType: 23,
                        resend:true
                      },
                    },
                  })
                },
                onCancel: () => {
                  this.doActions([
                    {
                      path:  "notice/sendNotice",
                      payload: {
                        key: "sendNoticeKey",
                        apiParams: {
                          bizId: bizIds,
                          bizType: 23,
                          resend:false
                        },
                      },
                    },
                  ]);
                }
              });
              }else{
                this.doActions([
                  {
                    path:  "notice/sendNotice",
                    payload: {
                      key: "sendNoticeKey",
                      apiParams: {
                        bizId: 0-bizIds,
                        bizType: 23,
                        resend:false
                      },
                    },
                  },
                ]);
              }
            }
            return true;
          } else {
            wizNotice.error(o['msg']);
            return false;
          }
        },
        participateExport: this._handleParticipateFile,
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ActivityManager);
